export default __webpack_public_path__ + "static/media/timer.224a92df.png";